import React from 'react'
import PageLoader from '../PageHelpers/PageLoader'


// aria-busy sagt dem Screenreader, dass hier noch gerechnet wird (#178).
const ResultsListLoading = () => (
    <div className="jm-results-loading" aria-busy="true">
        <PageLoader />
    </div>
)

export default ResultsListLoading